import React, { useState, useEffect } from "react";
import calendarPng from 'assets/images/calendar.png';
import { Button, ButtonProps } from "antd";
import ModalEndSubmit from "components/Organisms/Modals/ModalEndSubmit/ModalEndSubmit";
import ErrorBox from "components/Atoms/Alerts/ErrorBox";
import alertIcon from "../../../../assets/images/alert-triangle.svg";

interface Props extends ButtonProps{
  onClick: any;
  modalConfirm?: {
    show: boolean;
    confirmDescription?: string;
  }
  messageErrorDisabled?: string;
  showErrorBox?: boolean;
}

const ButtonSubmit = ({ onClick, modalConfirm, messageErrorDisabled, showErrorBox: propShowErrorBox, ...props }: Props) => {
  const [isModalSubmit, setModalSubmit] = useState(false);
  const [showErrorBox, setShowErrorBox] = useState(false);

  useEffect(() => {
    if (!propShowErrorBox) {
      setShowErrorBox(false);
    }
  }, [propShowErrorBox])

  const submit = (e: any) => {
    if(modalConfirm) setModalSubmit(true);
    else if(onClick) onClick(e);
  }

  return (
    <>
      <div style={{ position: 'relative' }}>
        <Button className="button button-submit" onClick={submit} {...props}>
          {props.children}
        </Button>
        {props.disabled && (
          <div
            onClick={() => {
              if (propShowErrorBox) 
                setShowErrorBox(true);
            }}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              cursor: 'not-allowed',
              backgroundColor: 'transparent'
            }}
            />
        )}
      </div>
      {modalConfirm && (
        <ModalEndSubmit
          visible={isModalSubmit}
          setVisible={setModalSubmit}
          buttonAction={{
            hidden: true
          }}
          modal={{
            title: 'Ready to submit?',
            description: (
              <h4 className="h4 h4-w4">{modalConfirm.confirmDescription || "After submitting, you'll have to contact us to make any changes."}</h4>
            )
          }}
          buttonSubmit={
            <Button
              className="button button-modal-ok"
              onClick={(e) => {
                setModalSubmit(false);
                if(onClick) onClick(e);
              }}
              {...props}
            >
              Yes, this is correct
            </Button>
          }
          buttonCancel={(actionCancel: any) => (
            <Button
              className="button button-modal-cancel"
              onClick={actionCancel}
            >
              I want to make changes
            </Button>
          )}
          icon={calendarPng}
          className="modal-end-submit--white"
        />
      )}
      {showErrorBox && messageErrorDisabled && (
        <ErrorBox text={messageErrorDisabled} img={alertIcon} className="mt-10" />
      )}
    </>
  );
};
export default ButtonSubmit;
